import React, { useState, useRef, useEffect , useMemo, useCallback} from "react";
import { useNavigate } from "react-router-dom";
import { AgGridReact } from 'ag-grid-react';
import customFetch from './customFetch';


const User = () => {
    const navigate = useNavigate();

    const gridRef = useRef(null);

    const [colDefs, setColDefs] = useState([]);
    const [rowData, setRowData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [fetchDataOnce, setFetchDataOnce] = useState(false);
    const [defaultColDef, setDefaultColDef] = useState({});

    useEffect(() => {
        let user = null;
        try {
             user = JSON.parse(localStorage.getItem("user"))
        } catch (e) {
            localStorage.removeItem("user")
        }
        if (!user || !user.token) {
          console.log('no auth')
          navigate("/login")
          return;
        }
        (async() => {
            let r = await customFetch("/api/verify", {
                method: "GET",
                headers: {'authorization': user.token}
              })
          if (r.status === 200) {
            console.log('auth+')
          } else {
            console.log('auth-')
            localStorage.removeItem("user")
            navigate("/login")
          }
          
          setIsLoading(true);
          setDefaultColDef({
            editable: false,
            cellDataType: false
        })
        setColDefs([
          { headerName: "Дата", field: "date", width: 120, cellDataType: 'text', filter: "agTextColumnFilter", sort: "desc"},
          { headerName: "Магазин", field: "shop", flex: 1 , cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Адрес", field: "address", flex: 1 , cellDataType: 'text', filter: "agTextColumnFilter"},
          { headerName: "Распознано", field: "ai_ok", width: 130, cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Не распознано", field: "ai_fail", width: 150 , cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Вручную", field: "ai_user", width: 120 , cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Очередь", field: "ai_queue", width: 120 , cellDataType: 'number', filter: "agNumberColumnFilter"},
          { headerName: "Всего", field: "total", width: 100 , cellDataType: 'number', filter: "agNumberColumnFilter"},
        ]);
    
          (async () => {
            let r = null;
            try {
              r = await customFetch("/api/report", {
                method: "GET",
                headers: {'authorization': user.token}
              });
              r = await r.json();
            } catch (e) {
                r = null;console.log(e);
            } finally {
                setFetchDataOnce(true);
                setIsLoading(false);
                if (r) {
                    setRowData(r);
                }
            }
          })();


        }) ()
      }, [])


    return (
      <div style={{position: 'absolute', height: '100vh', width: '100vw'}}>
      <div className="ag-theme-quartz" style={{ height: '100%', padding: '10px' }}>
            <AgGridReact 
            loading={isLoading}
            rowData={rowData}
            columnDefs={colDefs}
            defaultColDef={defaultColDef}
            ref={gridRef}
            enableCellTextSelection={true}
            />
            </div>
      </div>

    
    );
}

export default User